import Login from "./pages/auth/Login"
import IllustrationImageUsageReport from "./pages/IllustrationUsageReport"
import Illustrations from "./pages/illustrations"
import PromptPlayground from "./pages/playground/prompt"
import Logs from "./pages/logs"
import VerifyOtpForTwoFa from "./pages/auth/VeriyOtpForTwoFa"
import routePaths from "./constants/path"
import PatientIssuers from "./pages/PatientIssuers"
import IllustrationMappings from "./pages/IllustrationMappings"
import { userRoles } from "./constants"
import OrderTracking from "./pages/Orders/OrderTracking/OrderTracking"
import OrderComponents from "./pages/OrderComponents/OrderComponents"
import OrderStatistics from "./pages/OrderComponents/OrderStatistics"
import ResultsStatistics from "./pages/OrderComponents/ResultsStatistics"
import V3Reports from "./pages/V3Reports/V3Reports"
import ClinicalQA from "./pages/ClinicalQA/ClinicalQA"
import ErrorLogs from "./pages/IllustrationLogs"
import ErrorRelatedReports from "./pages/ErrorRelatedReports"
import AuditLogs from "./pages/AuditLogs"
import SingleAuditLog from "./pages/SingleAuditLog"
import ReroutedReports from "./pages/ReroutedReports"
import MissingPathologies from "./pages/MissingPathologiesStats"
import ErrorCodes from "./pages/ErrorCodes"
import NewLogs from "./pages/NewLogs"
import EducationalVideos from "./pages/EducationalVideos"
import CustomerFeedback from "./pages/CustomerFeedback"

const extractAllRoutes = (routes) => {
  const allRoutes = []

  function traverseRoutes(routeArray) {
    for (const route of routeArray) {
      if (route.path) {
        allRoutes.push(route)
      }
      if (route.children && route.children.length > 0) {
        traverseRoutes(route.children)
      }
    }
  }

  traverseRoutes(routes)
  return allRoutes
}

export const appRoutes = [
  {
    path: routePaths.homepage,
    name: "Logs",
    element: <NewLogs />,
    otpVerified: true,
    isMenuItem: true,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  },
  // {
  //   name: "Logs",
  //   path: null,
  //   otpVerified: true,
  //   isMenuItem: true,
  //   canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  //   children: [
  //     {
  //       name: "Logs",
  //       path: routePaths.logs,
  //       children: [],
  //       element: <Logs />,
  //       isMenuItem: true,
  //       otpVerified: true,
  //       canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  //     },
  //   ],
  // },
  {
    path: routePaths.singleAuditLog,
    name: "Audit Log",
    element: <SingleAuditLog />,
    isMenuItem: false,
    otpVerified: true,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  },
  {
    path: routePaths.errorReports,
    name: "Illustration Reports",
    element: <ErrorRelatedReports />,
    isMenuItem: false,
    otpVerified: true,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  },
  {
    name: "Patient Issuers",
    children: [],
    path: routePaths.managePatientIssuers,
    element: <PatientIssuers />,
    isMenuItem: true,
    otpVerified: true,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  },
  {
    name: "Two-Factor Authentication(Verify OTP)",
    children: [],
    path: routePaths.verifyTwoFa,
    element: <VerifyOtpForTwoFa />,
    isMenuItem: false,
    otpVerified: false,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG, userRoles.CUSTOMER],
  },
  {
    path: routePaths.customerFeedback,
    name: "Customer Feedback",
    element: <CustomerFeedback />,
    otpVerified: true,
    isMenuItem: true,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  },
  {
    path: routePaths.illustrationMappings,
    name: "Pathology Mappings",
    element: <IllustrationMappings />,
    otpVerified: true,
    isMenuItem: true,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  },
  {
    name: "Reports",
    path: null,
    otpVerified: true,
    isMenuItem: true,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
    children: [
      {
        name: "Rerouting",
        children: [],
        path: routePaths.reroutedReports,
        element: <ReroutedReports />,
        otpVerified: true,
        canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      },
      {
        name: "Missing Pathologies",
        children: [],
        path: routePaths.missingPathologies,
        element: <MissingPathologies />,
        otpVerified: true,
        canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      },
      // {
      //   path: routePaths.illustrationImageUsageReport,
      //   name: "Illustration Usage Report",
      //   element: <IllustrationImageUsageReport />,
      //   otpVerified: true,
      //   canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      // },
    ],
  },
  {
    name: "Legacy Logs",
    path: null,
    otpVerified: true,
    isMenuItem: true,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
    children: [
      {
        path: routePaths.illustrations,
        name: "Spine Logs",
        element: <Illustrations />,
        otpVerified: true,
        canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      },
      {
        path: routePaths.errorLogs,
        name: "Illustration Logs",
        element: <ErrorLogs />,
        otpVerified: true,
        canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      },
      // {
      //   path: routePaths.illustrationImageUsageReport,
      //   name: "Illustration Usage Report",
      //   element: <IllustrationImageUsageReport />,
      //   otpVerified: true,
      //   canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      // },
    ],
  },
  {
    name: "Debug Tools",
    path: null,
    isMenuItem: true,
    canAccess: [userRoles.DEBUG],
    children: [
      {
        name: "Prompt Playground",
        path: routePaths.playground,
        element: <PromptPlayground />,
        children: [],
        otpVerified: true,
        isMenuItem: true,
        canAccess: [userRoles.DEBUG],
      },
      {
        name: "Dashboard",
        path: routePaths.orderComponents,
        otpVerified: true,
        canAccess: [userRoles.DEBUG],
        element: <OrderComponents />,
      },
      {
        name: "Order Tracking",
        path: routePaths.orderTracking,
        otpVerified: true,
        canAccess: [userRoles.DEBUG],
        element: <OrderTracking />,
      },
      {
        path: routePaths.auditLogs,
        name: "Audit Logs",
        element: <AuditLogs />,
        otpVerified: true,
        canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      },
      {
        name: "Error Codes",
        children: [],
        path: routePaths.errorCodes,
        element: <ErrorCodes />,
        isMenuItem: true,
        otpVerified: true,
        canAccess: [userRoles.ADMIN, userRoles.DEBUG],
      },
      {
        name: "Clinical QA",
        isMenuItem: true,
        canAccess: [userRoles.DEBUG],
        otpVerified: true,
        path: routePaths.clinicalQA,
        element: <ClinicalQA />,
      },
    ],
  },
  {
    name: "Order Stats",
    path: routePaths.orders,
    element: <OrderStatistics />,
    children: [],
    otpVerified: true,
    isMenuItem: false,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  },
  {
    name: "Results Stats",
    path: routePaths.results,
    element: <ResultsStatistics />,
    children: [],
    otpVerified: true,
    isMenuItem: false,
    canAccess: [userRoles.ADMIN, userRoles.DEBUG],
  },
]

export const protectedRoutes = extractAllRoutes(appRoutes)

export const publicRoutes = [
  {
    path: routePaths.login,
    element: <Login />,
  },
  {
    path: routePaths.v3Reports,
    element: <V3Reports />,
  },
  {
    path: routePaths.educationalVideos,
    element: <EducationalVideos />,
  },
]
